var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reset-password-container" }, [
    _c(
      "div",
      { staticClass: "reset-password-box" },
      [
        _c("div", { staticClass: "reset-password-header" }, [
          _c(
            "button",
            { staticClass: "close", on: { click: _vm.goHomepage } },
            [_vm._v("×")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "header-logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "header-title" }, [
            _vm._v("Reset Password"),
          ]),
        ]),
        _vm._v(" "),
        _vm.resetSuccess
          ? _c("el-alert", {
              attrs: {
                title: "Reset password successful",
                type: "success",
                description: "Your password successfully reset.",
                "show-icon": "",
              },
            })
          : [
              _c(
                "div",
                { staticClass: "reset-password-auth-body" },
                [
                  _vm.error
                    ? _c("el-alert", {
                        attrs: {
                          title: "Sorry, something went wrong",
                          type: "error",
                          description: _vm.error,
                          "show-icon": "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userData
                    ? _c(
                        "el-form",
                        {
                          ref: "resetForm",
                          attrs: { model: _vm.form, rules: _vm.rules },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Password",
                                "inline-message": true,
                                prop: "password",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "password",
                                  size: "medium",
                                  autocomplete: "off",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.form.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "password", $$v)
                                  },
                                  expression: "form.password",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Confirm new password",
                                prop: "checkPass",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "password",
                                  size: "medium",
                                  autocomplete: "off",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.form.checkPass,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "checkPass", $$v)
                                  },
                                  expression: "form.checkPass",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.userData.mobile
                            ? [
                                _c("p", [
                                  _vm._v(
                                    "\n                We have sent a text message to your mobile number. Please enter the\n                6 digit code from that message below:\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "request-token",
                                    attrs: {
                                      "inline-message": true,
                                      prop: "token",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { size: "medium" },
                                      model: {
                                        value: _vm.form.token,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "token", $$v)
                                        },
                                        expression: "form.token",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "Your token expires in 2 minutes. If you do not have access to your mobile number then please call 02 8356 0300"
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-action" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn-submit",
                                  attrs: {
                                    type: "success",
                                    disabled: _vm.loading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitForm("resetForm")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Save\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }